module.exports = __webpack_public_path__ + "static/media/res1.57df534a.png";